import Box from "@mui/material/Box";
import {useDispatch, useSelector} from "react-redux";
import {apiGetProducts} from "api/productApi";
import BasicSelect from "components/BasicInputs/BasicSelect";
import useDateState from "helpers/useDateState";
import {useEffect, useState} from "react";

export default function TableSelectTax({refetch}: { refetch: any }) {
    const dispatch = useDispatch();
    const [option, setOption] = useState("sale");
    const {fromDate, toDate} = useDateState();
    const store = useSelector((state: any) => state);
    const {token} = store.businessReducer.business;
    const paginationState = store.paginationReducer;

    useEffect(() => {
        dispatch(
            // @ts-ignore
            apiGetProducts({pagination: {limit: 10000, page: 1, notTable: true}, token, search: "", sort: ""})
        );
    }, [token]);

    useEffect(() => {
        let options: any[] = [];
        if (fromDate && toDate) {
            options = [
                {key: "subColumn", value: "date"},
                {key: "searchText", value: fromDate},
                {key: "searchTextAlt", value: toDate},
            ];
        }
        dispatch(refetch({pagination: paginationState, token, search: options, type: option}));
    }, [token, option]);

    return (
        <Box
            sx={{
                minWidth: 120,
                maxWidth: 330,
                alignItems: "center",
                display: "flex",
                justifyContent: "space-between",
            }}
        >
            <BasicSelect
                options={[
                    {label: "فروش", value: "sale"},
                    {label: "خرید", value: "buy"},
                ]}
                onChange={(val) => {
                    setOption(val);
                }}
                defaultValue={option}
            />
            {/* <FormControl fullWidth sx={{ maxWidth: 300 }}>
        <StyledSelect
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          // @ts-ignore
          value={option}
          // @ts-ignore
          onChange={handleChange}
        >
          <MenuItem key={shortid.generate()} value="sale">
            فروش
          </MenuItem>
          <MenuItem key={shortid.generate()} value="buy">
            خرید
          </MenuItem>
        </StyledSelect>
      </FormControl> */}
        </Box>
    );
}
